export default __webpack_public_path__ + "static/media/chevron-up-solid.ba714d31.svg";